import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const UrgencyCountdown: React.FC = () => {
  // Start with 23:47:18
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 47,
    seconds: 18
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            }
          }
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <>
      <section className="bg-gradient-to-br from-red-dark to-red-main py-[30px] px-5 text-center text-white" data-id="element-291" data-mp="1t6mj4gjvxgox">
        <div className="text-sm font-sans font-bold tracking-[2px] uppercase opacity-90 mb-3" data-id="element-292" data-mp="3g1xgjo1c2rnv">
          ⏰ Precio de lanzamiento — Cierra en:
        </div>
        <div className="flex justify-center gap-2 items-center mb-3 md:gap-1.5" data-id="element-293" data-mp="3p2dkeylzo0t9">
          <div className="bg-black/30 rounded-lg py-2.5 px-4 min-w-[60px] md:min-w-[50px] md:py-2 md:px-3" data-id="element-294" data-mp="3u1q3d89qonqk">
            <span className="block text-[32px] font-black leading-none font-sans" data-id="element-295" data-mp="2xc91739ytjtm">
              {formatTime(timeLeft.hours)}
            </span>
            <span className="block text-[11px] font-sans opacity-80 uppercase tracking-[1px] mt-0.5" data-id="element-296" data-mp="31du724o30xub">
              hs
            </span>
          </div>
          <span className="text-[28px] font-black opacity-70 mb-1.5" data-id="element-297" data-mp="3b3nklb7sbn17">:</span>
          <div className="bg-black/30 rounded-lg py-2.5 px-4 min-w-[60px] md:min-w-[50px] md:py-2 md:px-3" data-id="element-298" data-mp="3b4ykv120ucnk">
            <span className="block text-[32px] font-black leading-none font-sans" data-id="element-299" data-mp="2imt9nl2m1acv">
              {formatTime(timeLeft.minutes)}
            </span>
            <span className="block text-[11px] font-sans opacity-80 uppercase tracking-[1px] mt-0.5" data-id="element-300" data-mp="3lwfjhr2gagko">
              min
            </span>
          </div>
          <span className="text-[28px] font-black opacity-70 mb-1.5" data-id="element-301" data-mp="3upsnbo21z2lj">:</span>
          <div className="bg-black/30 rounded-lg py-2.5 px-4 min-w-[60px] md:min-w-[50px] md:py-2 md:px-3" data-id="element-302" data-mp="3us54w03wfay2">
            <span className="block text-[32px] font-black leading-none font-sans" data-id="element-303" data-mp="3qqtbrkltg7l4">
              {formatTime(timeLeft.seconds)}
            </span>
            <span className="block text-[11px] font-sans opacity-80 uppercase tracking-[1px] mt-0.5" data-id="element-304" data-mp="2y0td43hwrqqp">
              seg
            </span>
          </div>
        </div>
        <p className="text-sm font-sans opacity-90" data-id="element-305" data-mp="370ptlhu59jao">
          ⚠️ Después sube <strong className="text-gold-main" data-id="element-306" data-mp="372kit8cg7xkk">$8.000 ARS</strong>
          . No vuelve al precio actual.
        </p>
      </section>

      <div className="bg-[#FFF8F0] p-5 text-center" data-id="element-307" data-mp="mah84k98qvj9">
        <div className="text-sm font-sans text-brown-light font-bold mb-2" data-id="element-308" data-mp="m9z6f83t7p3y">
          🔴 Cupos al precio de lanzamiento
        </div>
        <div className="max-w-[400px] mx-auto bg-[#E8E8E8] rounded-full h-[14px] overflow-hidden" data-id="element-309" data-mp="ysupx1wuknxl">
          <motion.div className="h-full bg-gradient-to-r from-brown-light to-red-main rounded-full" initial={{
          width: '0%'
        }} animate={{
          width: '68%'
        }} transition={{
          duration: 2,
          ease: 'easeOut'
        }} data-id="element-310" data-mp="kt1x911rfxmz" />
        </div>
        <p className="text-xs text-[#999] font-sans mt-1.5" data-id="element-311" data-mp="1djtve42dywcy">
          68% de los cupos al precio de lanzamiento ya tomados
        </p>
      </div>
    </>;
};